import React from 'react';

const PdfEmbed = (props) => {
  const { pdfUrl } = props;

  return (
    <div style={{border: '1px solid #999999', marginBottom: '1em', height: 602}}>
      <object data={pdfUrl} type="application/pdf" width="100%" height="600px">
        <p>
          Your browser does not support PDFs.{' '}
          <a href={pdfUrl} target="_blank">Download the PDF</a>.
        </p>
      </object>
    </div>
  );
};

export default PdfEmbed;
